import { z } from 'zod';
import { User } from '../../helpers/User';

export const schema = z.object({
  email: z.string().email('Email is required'),
  password: z.string().min(1, 'Password is required'),
});

export type InputType = z.infer<typeof schema>;

export type OutputType =
  | {
      user: User;
    }
  | {
      requires2FA: true;
      tempToken: string;
    };

export const postLogin = async (
  body: z.infer<typeof schema>,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/auth/login_with_password`, {
    method: 'POST',
    body: JSON.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    credentials: 'include', // Important for cookies to be sent and received
  });

  if (!result.ok) {
    const errorData = await result.json();
    throw new Error(errorData.message || 'Login failed');
  }

  return result.json() as Promise<OutputType>;
};
